const VENUES = 'venues';
const USERS = 'users';
const EMAILS = 'emails';
const SETTINGS = 'settings';
const BOOKINGS = 'bookings';

export const COLLECTION = {
  VENUES,
  USERS,
  EMAILS,
  SETTINGS,
  BOOKINGS
};
